import React from 'react';
import styled from 'styled-components';
import { CheckboxLabel } from './style';

const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
`;

const Icon = styled.svg`
    fill: none;
    stroke: white;
    stroke-width: 2px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

const StyledCheckbox = styled.div`
  width: 16px;
  height: 16px;
  background: ${props => (props.checked ? 'salmon' : 'papayawhip')}
  border-radius: 2px;
  transition: all 150ms;
  width: 18px;
  height: 18px;
  background-color: ${props => (props.checked ? '#fff' : 'rgba(239, 240, 242, 0.18)')};

//   ${HiddenCheckbox}:focus + & {
//     box-shadow: 0 0 0 3px pink;
//   }

//   ${Icon} {
//     visibility: ${props => (props.checked ? 'visible' : 'hidden')}
//   }
`;

export const Checkbox = ({ className, checked, label, ...props }) => (
    <CheckboxContainer>
        <HiddenCheckbox checked={checked} {...props} />
        <StyledCheckbox checked={checked} />
        <CheckboxLabel>{label}</CheckboxLabel>
    </CheckboxContainer>
);



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/CreateEditInput/Checkbox.js